export function docsPath(slug: string): string {
  if (!slug) {
    return '/docs'
  }
  return `/docs/${slug}`
}

export function searchLocationToPath(location: string): string {
  const trimmed = location.replace(/\/$/, '')
  const hashIndex = trimmed.indexOf('#')
  if (hashIndex === -1) {
    return trimmed ? `/docs/${trimmed}` : '/docs'
  }

  const slug = trimmed.slice(0, hashIndex)
  const hash = trimmed.slice(hashIndex + 1)
  const base = slug ? `/docs/${slug}` : '/docs'
  return `${base}#${hash}`
}

export function normalizeDocsPathname(pathname: string): string {
  return pathname.replace(/\/$/, '') || '/docs'
}
